import React, { useState } from 'react';
import { Tag } from 'antd';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';

const Invoices = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const mapToTable = (customTypes) => {
    const data = [];

    customTypes.forEach(({ id, total, time, status }, index) => {
      data.push({
        id,
        key: index,
        status: status === 'paid' ? 'Paid' : 'Not Paid',
        time: new Date(time).toLocaleString(),
        total: `${total}GEL`
      });
    });

    return data;
  };

  const customTypes = [
    {
      id: '001',
      status: 'paid',
      time: '04.04.19',
      total: '300'
    },
    {
      id: '002',
      status: 'notpaid',
      time: '10.02.19',
      total: '50'
    },
    {
      id: '003',
      status: 'paid',
      time: '05.04.19',
      total: '80'
    },
    {
      id: '004',
      status: 'paid',
      time: '12.04.19',
      total: '54'
    }
  ];

  const filterData = (data) => {
    if (selectedFilter === 'All') {
      return data;
    }

    return data.filter((item) => item.status === selectedFilter);
  };

  const columns = [
    {
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id.localeCompare(b.id),
      title: 'ID'
    },
    {
      dataIndex: 'total',
      key: 'total',
      sorter: (a, b) => a.total.localeCompare(b.total),
      title: 'Total'
    },
    {
      dataIndex: 'time',
      key: 'time',
      sorter: (a, b) => a.time.localeCompare(b.time),
      title: 'Time'
    },
    {
      align: 'right',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Tag
              // color={status === "Paid" ? "#41CC9C" : "#F4D325"}
              key={status}
              style={
                status === 'Paid'
                  ? {
                      alignItems: 'center',
                      backgroundColor: 'rgba(65, 204, 156, 0.15)',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#41CC9C',
                      display: 'flex',
                      height: '28px',
                      justifyContent: 'center',
                      width: '46px'
                    }
                  : {
                      alignItems: 'center',
                      backgroundColor: 'rgba(244, 211, 37, 0.15)',
                      border: 'none',
                      borderRadius: '8px',
                      color: '#F4CD00',
                      display: 'flex',
                      height: '28px',
                      justifyContent: 'center',
                      width: '74px'
                    }
              }
            >
              {status}
            </Tag>
          </div>
        );
      },
      sorter: (a, b) => a.status.localeCompare(b.status),
      title: 'Status'
    }
  ];

  const downloadInvoice = () => {
    console.error('download invoice link should be here');
  };

  const selectRow = () => {
    return () => {
      // selected row's item is available here
    };
  };

  // const onCustomTypeDelete = async () => {
  //   for (const index of selectedRowKeys) {
  //     const item = data[index];

  //     await deleteCustomType(item._id, currentProject._id);
  //   }

  //   setSelectedRowKeys([]);
  //   dispatch(fetchCustomType());
  // };

  const actions = [{ onClick: downloadInvoice, title: 'Download PDF', type: 'primary' }];

  //   const currentProject = useSelector(({ project }) => project.currentProject);

  //   useEffect(() => {
  //     async function load() {
  //       dispatch(fetchCustomType());
  //     }

  //     if (currentProject) {
  //       load();
  //     }

  //   }, [currentProject, dispatch]);

  //   const isLoaded = useSelector(({ customType }) => customType.isLoaded);

  //   const customTypes = useSelector(({ customType }) => customType.customTypes);
  const data = mapToTable(customTypes);

  // const filterListContentModel = ['All', ...new Set(data.map((item) => item.contentType))];

  const filterList = ['All', ...new Set(data.map((item) => item.status))];
  const [selectedFilter, setSelectedFilter] = useState(filterList[0]);
  const onFilterChange = (value) => {
    console.error(value);
    setSelectedFilter(value);
  };

  const filteredData = filterData(data);

  // if (!currentProject) {
  //     return Loader();
  // }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={customTypes.length} title="Invoices" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={filteredData}
        // filterContentModel={filterListContentModel}
        // filterStatus={filterList}
        filter={filterList}
        onFilterChange={onFilterChange}
        onRowClick={selectRow}
        searchBy="id"
        // loading={!isLoaded}
        selectedFilter={selectedFilter}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default Invoices;
